import React from "react";

function ProductGridItems(props) {
  const { children } = props;

  return <>{children}</>;
}

export default ProductGridItems;
